import React, { useState, useCallback } from 'react'
import type { TransitionControllerProps } from './types'

import { createContext, useContext } from 'react'

export interface TransitionControllerContextState {
  trigger: () => void
  isTriggered: boolean
  handleTransitionEnd: () => void
}

export const TransitionControllerContext =
  createContext<TransitionControllerContextState>(
    {} as TransitionControllerContextState,
  )

export const useTransitionController = () => {
  const context = useContext(TransitionControllerContext)
  if (!context) {
    throw new Error(
      'useTransitionController must be used within a TransitionController provider',
    )
  }
  return context
}

export const TransitionProvider: React.FC<TransitionControllerProps> = ({
  children,
  onTransitionEnd,
}) => {
  const [isTriggered, setIsTriggered] = useState(false)

  const trigger = useCallback(() => {
    setIsTriggered(true)
  }, [])

  const handleTransitionEnd = useCallback(() => {
    setIsTriggered(false)
    onTransitionEnd?.()
  }, [onTransitionEnd])

  const contextValue: TransitionControllerContextState = {
    trigger,
    isTriggered,
    handleTransitionEnd,
  }

  return (
    <TransitionControllerContext.Provider value={contextValue}>
      {children}
    </TransitionControllerContext.Provider>
  )
}
